// extracted by mini-css-extract-plugin
export default {"Container":"contaner_Container__O2GUR","gray":"contaner_gray__E9WME","orange":"contaner_orange__o6PYD","transparent":"contaner_transparent__44O50"};